import App from "@frog/source/models/App.js"
import Random from "@frog/source/utility/Random.js"
import Navigation from "@frog/source/models/Navigation.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"

const CRITICAL_EVENTS = {
    3: function() {
        return [
            "You feel a chill down your spine - you are being hunted.",
            {"func": () => Navigation.go("/games/ember/chapters/1")},
            {
                "func": () => {
                    App.game.overworld.nextEvent = function(stage) {
                        return [
                            "The beasts are defeated, and you are safe.",
                            "(If someone died, we'd mourn them here before carrying on.)",
                        ]
                    }
                }
            }
        ]
    },
    5.35: function() {
        return [
            "What's this? A campfire with hot soup all ready to eat?",
            "Looks like a fine place for our travelers to relax.",
            "And they'll need their rest",
            "For the darkest and most dangerous part of the journey is yet to come!",
            PlotSteps.Wait(200),
            "(If you have food, you can heal and recover)",
        ]
    },
    6: function() {
        return [
            "You are ambushed by bandits - they demand all that you have.",
            {"func": () => Navigation.go("/games/ember/chapters/1")},
            {
                "func": () => {
                    App.game.overworld.nextEvent = function(stage) {
                        return [
                            "The bandits flee, brought to heel.",
                        ]
                    }
                }
            }
        ]
    },
    10: function() {
        return [
            "You face death.",
            {"func": () => Navigation.go("/games/ember/chapters/1")},
            {
                "func": () => {
                    App.game.overworld.nextEvent = function(stage) {
                        return [
                            "You cannot evade death forever, but some of you have evaded death for now.",
                        ]
                    }
                }
            }
        ]
    },
    12.3: function() {
        return [
            "You have made it to the edge of the dark forest. But what lies beyond it?",
            {"func": () => Navigation.go("/games/ember/chapters/1")},
        ]
    }
}

let INCIDENTAL_EVENTS = [
    function() {
        return [
            "It grows colder, but you trundle onwards.",
        ]
    },
    function() {
        return [
            "Along the road, you meet a curious traveler.",
            "They greet you quietly under their breath, but never make eye contact.",
            "They carry on past you."
        ]
    },
    function() {
        return [
            "You hear a cry for help from deeper in the woods. Do you approach?"
        ]
    },
    function() {
        return [
            "A heavy fog has rolled in. Do you continue at the same pace, or slow down? (You might get lost)"
        ]
    },
    function() {
        return [
            "Someone in your party has tripped and hurt their leg - they cannot keep up at the same pace. (You can leave them behind or stop)"
        ]
    },
    function() {
        return [
            "You come upon a circle of neolithic stones, covered in moss and lichen."
        ]
    },
    function() {
        return [
            "Just a bit off the path, you see a berry bush. (You might find berries, or trouble, or be poisoned)"
        ]
    },
    function() {
        return [
            "A heavy storm has begun. It would be foolish to continue onwards"
        ]
    },
    function() {
        return [
            "You took the wrong trail, and must backtrack (Takes longer to get where your'e going, eats more food)"
        ]
    },
    function() {
        return [
            "You find an abandoned wagon sitting in the center of the road. Do you investigate?"
        ]
    },
    function() {
        return [
            "A thief came in the night and stole x resources (start a questline where you can willingly give the thief resources and they'll join you)"
        ]
    },
    function() {
        return [
            "Someone in your party has caught a disease."
        ]
    },
    function() {
        return [
            "Someone in your party was bitten by a snake."
        ]
    },
    function() {
        return [
            "Someone in your party is suffering from exhaustion."
        ]
    },
    function() {
        return [
            "You have reached a small inn. It is dark at this hour. Do you knock?"
        ]
    },
    function() {
        return [
            "You see another caravan coming down the road. What do you do? (You come upon a traveling merchant.)"
        ]
    },
    function() {
        return [
            "You have reached a heavy river. How do you want to cross?"
        ]
    },
    function() {
        return [
            "Ahead on the path, you see a busted down war machine."
        ]
    },
    function() {
        return [
            "You see a crater where a fallen star has crashedlanded."
        ]
    },
    function() {
        return [
            "You hear a voice off in the darkness of the woods. It is singing a jolly song. Do you approach?",
            "You take a step forward, but snap a branch underfoot. The singing dies. The silence is deafening."
        ]
    },
    function() {
        return [
            "You come upon a rickety hovel in the middle of the woods. There is no door, just a gaping entrance. From the doorway, you can see there is nobody here. But hanging from the rafters are an assortment of dried meats and herbs."
        ]
    },
    function() {
        return [
            "Out in the darkness of the woods, you hear someone call out your name. It is the voice of a loved one. After a moment, the voice fades.",
        ]
    },
    function() {
        return [
            "Out in the darkness of the woods, you hear someone calling for help. You hear no sounds of combat or pursuit, just the voice crying for help. The voice desperately pleads for help, repeating their call for help again and again."
        ]
    },
    function() {
        return [
            "Thirsty, you approach a woodland pond. You halt. Bloody feathers float on the water around a figure bathing, as a woman tears them from her flesh. At the crunch of your frozen step, she turns her empty eye sockets to you",
            "“How can we cure this malady?” you ask. “He said the same thing. But this is who I am.” She continues plucking and from her feathers weaves a fine down blanket. “Please, take this to my newborn son in the human village”"
        ]
    },
    function() {
        return [
            "A peacock crosses the path ahead of you. In the center of each feather, an staring eye weeps."
        ]
    },
    function() {
        return [
            "While walking along the road at dusk the silhouette of a strapping farmhand moves quickly down the road behind you. He smells of iron.",
            "He is returning to his hometown after being conscripted. “I just wish I could finally tell Daisy how I feel”",
            "He carries on deep into the night about how strong and sincere and beautiful she is. “Thanks for listening to all that. Here, take my flute to the village inn and she'll know you're a friend of mine”. He races on ahead of you, but you never see him again"
        ]
    },
    function() {
        return [
            "A clearing of rosebushes and brambles opens before you. The blackberries are tart and the rosehips and full.",
            "“The briars will cut your hands and precious warming cloaks”. A woman appears behind you, her eyes defiant but rubbed as red as the petals falling around you."
        ]
    }
]

export default function Travel() {
    return (stage) => {
        let steps = []

        App.game.overworld.player = App.game.overworld.player || {}
        App.game.overworld.player.flags = App.game.overworld.player.flags || {}
        App.game.overworld.player.position = App.game.overworld.player.position || {"x": 1, "y": 2}

        let currentX = App.game.overworld.player.position.x
        for(let i = 0; i < 20; i += 1) {
            let nextX = currentX + (0.5 + (Math.random() * 0.5))

            const upcomingMilestoneKeys = Object.keys(CRITICAL_EVENTS).map((key) => Number.parseFloat(key)).filter((key) => currentX < key)
            const nextMilestoneKey = upcomingMilestoneKeys[0]
            let isAtNextMilestone = false

            if(nextMilestoneKey != undefined
            && currentX < nextMilestoneKey
            && nextX >= nextMilestoneKey) {
                nextX = nextMilestoneKey
                isAtNextMilestone = true
            }

            currentX = nextX
            steps.push({
                "func": function() {
                    App.game.overworld.player.position = {
                        "x": nextX,
                        "y": 2
                    }
                }
            })
            steps.push(PlotSteps.Wait(3000))

            if(isAtNextMilestone) {
                steps = steps.concat(CRITICAL_EVENTS[nextMilestoneKey]())
                break
            }

            INCIDENTAL_EVENTS = Random.shuffle(INCIDENTAL_EVENTS) // TODO: this is mutating!!
            const incidentalEvent = INCIDENTAL_EVENTS.shift()
            steps = steps.concat(incidentalEvent(stage))

            steps.push(PlotSteps.Wait(1000))
        }

        return steps
    }
}
